import { BaseModel } from "./baseModel";

export enum FallbackRecognizedStatus{
    solved,
    unsolved,
    ignored,
}
export interface FallbackRecognized extends BaseModel{
    status: FallbackRecognizedStatus;
    // assignedTo referencia a um usuário
    assignedTo?: string;
    tags: string[];
    text: string;
    workspaceId: string;
    botId: string;
    source: any;
}